import { API_FAILED, CLEAR_API_ERROR } from 'src/redux/Actions/Type';

const initialState = {
  errorMessages: [],
};

const globalError = (state = initialState, action = {}) => {
  const { type, payload } = action;

  switch (type) {
    case API_FAILED:
      return {
        ...state,
        errorMessages: [
          ...state.errorMessages,
          {
            id: payload.id,
            message: payload.message,
            errorList: payload.errorList,
          },
        ],
      };
    case CLEAR_API_ERROR:
      return {
        ...state,
        errorMessages: state.errorMessages.filter(
          (message) => message.id !== payload.id,
        ),
      };
    default:
      return state;
  }
};

export default globalError;
